<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('inventoryMinMax2.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('inventoryMinMax2.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('inventoryMinMax2.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('inventoryMinMax2.branchName')
                          }}</label>
                          <a-select
                            v-model="model.branch_id"
                            :options="branches"
                            class="ts-w-full"
                            mode="multiple"
                            placeholder="All"
                            @change="getLocations"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                          ></a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('inventoryMinMax2.warehouse')
                          }}</label>
                          <a-select
                            v-model="model.location_id"
                            :options="locations"
                            mode="multiple"
                            placeholder="All"
                            class="ts-w-full"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                          ></a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('inventoryListReport.category')
                          }}</label>
                          <a-select
                            v-model="model.category_id"
                            :options="categories"
                            mode="multiple"
                            showSearch
                            @change="clearProduct"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            class="ts-w-full"
                            :placeholder="$t('all')"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('category_id')"
                          >
                            {{ errors.first('category_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('inventoryListReport.group') }}</label>
                          <a-select
                            v-model="model.pro_group_id"
                            mode="multiple"
                            :options="groupsList"
                            showSearch
                            @change="clearProduct"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            class="ts-w-full"
                            :placeholder="$t('all')"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('pro_group_id')"
                          >
                            {{ errors.first('pro_group_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 form-group">
                        <label>{{ $t('inventoryListReport.product') }}</label>
                        <a-select
                          v-model="model.product_id"
                          mode="multiple"
                          :loading="on_search_product"
                          @search="onProductSearch"
                          :disabled="showSearchProduct"
                          :show-arrow="false"
                          :filter-option="true"
                          :not-found-content="null"
                          :placeholder="$t('all')"
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                        >
                          <a-select-option
                            v-for="product in productList"
                            :key="product.value"
                            :value="product.value"
                          >
                            {{ product.label }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('yearlySoldBySaleType.saleType') }}</label>
                          <a-select
                            style="width: 100%"
                            mode="multiple"
                            v-model="model.sale_type"
                            :options="posType"
                            placeholder="All"
                          >
                           </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('inventoryMinMax2.dateRange')
                          }}</label>
                           <a-range-picker
                              style="width: 100%"
                              :mode="mode"
                              format="MM-YYYY"
                              v-model="month_year_range"
                              valueFormat="MM-YYYY"
                              @panelChange="handlePanelChange"
                            />
                          <div class="validate" v-if="errors.has('month_year_range')">
                            {{ errors.first('month_year_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <ts-checkbox v-model="model.is_calculate_stock">
                            {{ $t('inventoryMinMax2.freezeInventiryMaxMin') }}
                          </ts-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          outline
                          color="success"
                          class="btn-block"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right" v-show="model.is_calculate_stock == true">
                        <ts-button
                          color="primary"
                          outline
                          class="btn-block"
                          @click.prevent="calculate"
                          :waiting="waiting"
                          >
                          {{ $t('inventoryMinMax2.calculate') }}
                        </ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right" v-show="model.is_calculate_stock == false">
                        <ts-button
                          color="primary"
                          outline
                          class="btn-block"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="far fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('inventoryMinMax2.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'inventoryMinMax2',
  data () {
    return {
      exporting: false,
      waiting: false,
      loading: false,
      errors: new Errors(),
      groups: [],
      categories: [],
      on_search_product: false,
      productList: [],
      branches: [],
      locations: [],
      src: '',
      mode: ['month', 'month'],
      month_year_range: [moment().startOf('year'), moment().endOf('year')],
      model: {
        is_calculate_stock: false,
        branch_id: undefined,
        location_id: undefined,
        pro_group_id: [],
        category_id: [],
        product_id: [],
        sale_type: undefined,
        month_year_range: [
          moment().startOf('year').format('MM-YYYY'),
          moment().endOf('year').format('MM-YYYY')
        ]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  computed: {
    showSearchProduct () {
      return this.model.location_id == '' || this.model.location_id == undefined
    },
    groupsList () {
      if (this.model.category_id) {
        return this.groups
          .filter(g => _.includes(this.model.category_id, g.category_id))
          .map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
      }
      return this.groups.map(el => ({
        value: el.pro_group_id,
        label: el.pro_group_name_en
      }))
    },
    posType () {
      return [
        { value: '1', label: 'Retail sale' },
        { value: '2', label: 'Whole sale' },
        { value: '3', label: 'Borrowing' }
      ]
    }
  },
  async created () {
    await this.getBranchs()
  },
  methods: {
    ...mapActions('report/resource', [
      'productGroup',
      'productCategory',
      'productProfileLocationList',
      'getBranch'
    ]),
    moment,
    async fetchData () {
      this.loading = true
      await this.productGroup().then(response => {
        this.groups = response.data
      })
      await this.productCategory()
        .then(response => {
          this.categories = response.data.map(el => ({
            value: el.category_id,
            label: el.category_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getBranchs() {
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.getLocations(false)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getLocations($check) {
      this.loading = true
      if ($check) {
        this.model.location_id = undefined
      }
      this.locations = []
      await this.$store
        .dispatch('report/inventory/getLocation', {
          branch_id: this.model.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePanelChange (value, mode) {
      this.month_year_range = value
      this.model.month_year_range[0] = moment(value[0]).format('MM-YYYY')
      this.model.month_year_range[1] = moment(value[1]).format('MM-YYYY')
      this.mode = [
        mode[0] === 'date' ? 'month' : mode[0],
        mode[1] === 'date' ? 'month' : mode[1]
      ]
    },
    onProductSearch: _.debounce(function (value) {
      this.on_search_product = true
      this.productProfileLocationList({
        filter: {
          search: value
        },
        category_id: this.model.category_id,
        pro_group_id: this.model.pro_group_id,
        location_id: this.model.location_id
      })
        .then(response => {
          let product = response.data.map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))

          let diff = _.differenceBy(...product, this.productList, 'value')

          if (!diff.length > 0) {
            this.productList.push(...product)
          } else {
            this.productList.push(...diff)
          }

          this.productList = _.uniqBy(this.productList, 'value').splice(0, 300)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.on_search_product = false
        })
    }, 500),
    clearProduct () {
      this.model.product_id = []
      this.productList = []
    },
    calculate() {
      this.$confirm({
        title: this.$t('are_you_sure_to_calculate'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.$store
            .dispatch('report/inventory/insertCalculateMaxMin', this.model)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
            })
        },
        onCancel() {}
      })
    },
    preview () {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/inventory/inventoryMinMax2', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/inventory/inventoryMinMax2Excel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
